import React, { Component } from 'react';
import './App.css';

import TodoList from './components/TodoList';

class App extends Component {
  render() {
    return (
      <div className="App">
        <TodoList></TodoList>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js